import { render, staticRenderFns } from "./NavTabList.vue?vue&type=template&id=0da75700&scoped=true&"
import script from "./NavTabList.vue?vue&type=script&lang=js&"
export * from "./NavTabList.vue?vue&type=script&lang=js&"
import style0 from "./NavTabList.vue?vue&type=style&index=0&id=0da75700&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da75700",
  null
  
)

export default component.exports